import { createClient } from '@supabase/supabase-js';

// Supabase configuration provided by the user
const supabaseUrl = 'https://auxhdlrbpzchwrdpqvre.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF1eGhkbHJicHpjaHdyZHBxdnJlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjYwMzA1MTcsImV4cCI6MjA4MTYwNjUxN30.gq3S4pZ-Rx-HtvaEGi6xkB_NK0U3Ozcu4FvtTm0kG-U';

export const isSupabaseConfigured = () => {
  return !!supabaseUrl && !!supabaseAnonKey;
};

// Initialize Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/**
 * Storage Helper for the 'Cheang' bucket
 */
export const uploadFile = async (path: string, file: File | Blob) => {
  const { data, error } = await supabase.storage
    .from('Cheang')
    .upload(path, file, {
      upsert: true
    });
  
  if (error) throw error;
  
  const { data: { publicUrl } } = supabase.storage
    .from('Cheang')
    .getPublicUrl(data.path);
    
  return publicUrl;
};

/**
 * Delete file helper to save space
 */
export const deleteFile = async (url: string) => {
  try {
    if (!url || !url.includes('storage/v1/object/public/Cheang/')) return;
    
    // Extract path from public URL
    const path = url.split('storage/v1/object/public/Cheang/')[1];
    if (!path) return;

    const { error } = await supabase.storage
      .from('Cheang')
      .remove([path]);
      
    if (error) console.error("Error deleting old file:", error);
  } catch (err) {
    console.error("Cleanup failed:", err);
  }
};
